var map = {
	"./BC.png": "7673",
	"./BCM.png": "d586",
	"./BEA.png": "43e3",
	"./BOC.png": "047b",
	"./BOCM.png": "81ff",
	"./CBC.png": "2fc1",
	"./CBCL.png": "99fb",
	"./CCB.png": "bbe4",
	"./CCBL.png": "9ef0",
	"./CHB.png": "6f49",
	"./CITIBANK.png": "cae8",
	"./CMB.png": "cc2f",
	"./CMBC.png": "e0ca",
	"./Citibank.png": "9afb",
	"./DBS.png": "c1a5",
	"./DBSB.png": "5f75",
	"./DSB.png": "550a",
	"./FPS.png": "cdb2",
	"./HSB.png": "ef33",
	"./HSBC.png": "ac68",
	"./ICBC.png": "7f95",
	"./NCB.png": "4574",
	"./OCBC.png": "4876",
	"./OTHER.png": "29107",
	"./SCB.png": "e34e",
	"./SIB.png": "2273",
	"./ZA.png": "ba7f",
	"./ZAB.png": "b074"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c65d";